import React, { useRef, useState } from "react";
import { Play } from "lucide-react";
import { SANDRA_VIDEO_URL, SANDRA_VIDEO_CAPTIONS_URL, SANDRA_VIDEO_POSTER, SANDRA_VIDEO_PORTRAIT } from "../../mock";

const isEmbed = (url) => /youtube\.com|youtu\.be|vimeo\.com/.test(url || "");

const embedSrc = (url) => {
  const yt = url.match(/(?:youtu\.be\/|v=|\/embed\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?rel=0&cc_load_policy=1&cc_lang_pref=en`;
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}?texttrack=en&dnt=1`;
  return url;
};

// "A quick word from Sandra": placeholder frame until SANDRA_VIDEO_URL is set; then tap-to-play, captions on.
export const SandraVideo = () => {
  const ref = useRef(null);
  const [started, setStarted] = useState(false);
  const url = (SANDRA_VIDEO_URL || "").trim();

  const play = async () => {
    setStarted(true);
    try {
      await ref.current.play();
    } catch (e) {}
  };

  return (
    <section className="w-[90%] max-w-[760px] mx-auto mt-20" data-testid="sandra-video">
      <p className="text-[12px] font-bold tracking-[0.18em] uppercase text-[#D4AF35] text-center">A Quick Word From Sandra</p>
      <div
        className={`mt-5 relative rounded-[1.5rem] overflow-hidden bg-[#111111] border border-[#2A2A2A] ${
          SANDRA_VIDEO_PORTRAIT && url ? "aspect-[9/16] w-full max-w-[340px] mx-auto" : "aspect-video w-full"
        }`}
      >
        {!url ? (
          <div className="absolute inset-0 flex items-center justify-center px-6" data-testid="sandra-video-placeholder">
            <span className="text-[11px] md:text-xs font-bold tracking-[0.25em] uppercase text-white/45 text-center">
              Sandra's Video Is Coming Soon
            </span>
          </div>
        ) : isEmbed(url) ? (
          <iframe
            src={embedSrc(url)}
            title="A quick word from Sandra"
            className="absolute inset-0 w-full h-full"
            allow="encrypted-media; picture-in-picture"
            allowFullScreen
            data-testid="sandra-video-embed"
          />
        ) : (
          <>
            <video
              ref={ref}
              src={url}
              poster={SANDRA_VIDEO_POSTER}
              playsInline
              controls={started}
              preload="metadata"
              className="absolute inset-0 w-full h-full bg-black"
              data-testid="sandra-video-player"
            >
              {SANDRA_VIDEO_CAPTIONS_URL && <track kind="captions" srcLang="en" label="English" src={SANDRA_VIDEO_CAPTIONS_URL} default />}
            </video>
            {!started && (
              <button
                onClick={play}
                aria-label="Play Sandra's video"
                data-testid="sandra-video-play"
                className="group absolute inset-0 flex items-center justify-center bg-black/40 focus-ring"
              >
                <span className="flex items-center justify-center w-16 h-16 rounded-full bg-[#D4AF35] text-[#0D0D0D] shadow-[0_12px_40px_-6px_rgba(212,175,53,0.7)] group-hover:scale-110 transition-transform">
                  <Play size={26} className="ml-1 fill-current" />
                </span>
              </button>
            )}
          </>
        )}
      </div>
      <p className="mt-4 text-sm text-white/55 text-center font-medium">
        About a minute. Captions on, so you can watch with the sound off.
      </p>
    </section>
  );
};
